import { Skeleton, Typography } from '@mui/material';
import Box, { BoxProps } from '@mui/material/Box';
import Button from '@mui/material/Button';
import CardHeader from '@mui/material/CardHeader';
import Stack from '@mui/material/Stack';
import { useTheme } from '@mui/material/styles';
import { isEmpty } from 'lodash';
import { useQueryState } from 'nuqs';
import { forwardRef } from 'react';
import { useResponsive } from 'src/hooks/use-responsive';
import { IEvent } from 'src/types/events';
// @mui
import 'swiper/css';
import Iconify from 'src/components/iconify';
import { register } from 'swiper/element/bundle';

import EventCard from '../home/event-card';

interface Props extends BoxProps {
  title?: string;
  subheader?: string;
  isSubscribed?: boolean;
  list?: IEvent[];
  isLoading: boolean;
}
register();

const UpcomingEvents = forwardRef(
  ({ title, subheader, list, isLoading, isSubscribed, sx, ...other }: Props, ref) => {
    const theme = useTheme();
    const mdUp = useResponsive('up', 'md');
    const [_, setOpenSubscribe] = useQueryState('openSubscribe');

    return (
      <Box>
        <CardHeader
          title={title ?? 'Trending'}
          sx={{
            p: 0,
            pb: 3,
          }}
        />
        {isLoading && <Skeleton sx={{ borderRadius: 1.5, height: '20rem', flexShrink: 0 }} />}
        {!isLoading && isEmpty(list) && (
          <Stack
            spacing={2}
            alignItems="center"
            justifyContent="center"
            width={1}
            border={0.5}
            borderRadius={2}
            height="100%"
            py={5}
            px={3}
          >
            <Iconify icon="line-md:bell-alert-twotone-loop" height={25} width={25} />
            <Typography
              variant="caption"
              align="center"
              fontSize={14}
              sx={{ color: theme.palette.grey[50] }}
            >
              Subscribe to get notified when new events are announced.
              <br /> Never miss an opportunity to join 😉
            </Typography>
            <Button onClick={() => setOpenSubscribe('true')}>
              {isSubscribed ? 'Subscribed' : 'Subscribe'}
            </Button>
          </Stack>
        )}
        {!isEmpty(list) &&
          (mdUp ? (
            <swiper-container
              grab-cursor="true"
              slides-per-view="2"
              space-between="30"
              autoplay-disable-on-interaction="true"
            >
              {list &&
                list.map((item) => (
                  <swiper-slide key={item.id}>
                    <EventCard event={item} />
                  </swiper-slide>
                ))}
            </swiper-container>
          ) : (
            <swiper-container
              effect="cards"
              grab-cursor="true"
              autoplay-disable-on-interaction="true"
            >
              {list &&
                list.map((item) => (
                  <swiper-slide key={item.id}>
                    <EventCard event={item} />
                  </swiper-slide>
                ))}
            </swiper-container>
          ))}
      </Box>
    );
  }
);

export default UpcomingEvents;
